import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import Loader from '../components/Loader';

const CoHost = () => {
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const logoImgRefs = useRef([]);
    const coverImgRefs = useRef([]);
    const loadedCount = useRef(0);

    const updateHeights = () => {
        logoImgRefs.current.forEach((logo, index) => {
            const cover = coverImgRefs.current[index];
            if (logo && cover) {
                const height = logo.offsetHeight;
                cover.style.height = `${height}px`;
                console.log(height);
            }
        });
    };

    useEffect(() => {
        const fetchListings = async () => {
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);

            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    url: `${params.baseURL}${params.endpoints.getMyCalendar}`,
                    data: formData
                });

                if (response.data.items && Array.isArray(response.data.items)) {
                    setListings(response.data.items);
                    setLoading(false);
                } else {
                    setError('An error occurred while fetching data.');
                }
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        };

        fetchListings();
    }, []);

    const handleImageLoad = (index) => {
        loadedCount.current += 1;
        if (loadedCount.current === listings.length * 2) {
            updateHeights();
        }
    };

    useEffect(() => {
        if (listings.length > 0) {
            window.addEventListener('resize', updateHeights);
            return () => {
                window.removeEventListener('resize', updateHeights);
            };
        }
    }, [listings]);

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <p>Error loading listings: {error.message}</p>;
    }

    return (
        <div>
            <Helmet>
                <title>Co-Host</title>
                <meta name="description" content="" />
            </Helmet>
        
            <div className='row'>
                <div className='col-md-4 listing-img-box'>
                    <div>
                        <img src={'/assets/img/banners/co_host_banner.webp'} alt="Listing Image" className="listing-image" />
                    </div>
                </div>
                <div className='col-md-8 offset-md-4'>
                    {listings.length > 0 ? (
                        <div className='row'>
                            {listings.map((listing, index) => (
                                <div className='col-md-6 lb' key={listing.stay_listing_id}>
                                    <a href={`/manage-co-host/${listing.stay_listing_id}`}>
                                        <div className='acc-box' style={{ marginBottom: '10px' }}>
                                            <div className="apimgcibox">
                                                <div className='image-wrapper lcibox'>
                                                    <div className='ac-cover-image'>
                                                        <img
                                                            ref={(el) => (coverImgRefs.current[index] = el)}
                                                            className="ciso ap-ciso"
                                                            src={listing.cover_photo ? listing.cover_photo : '/assets/img/default_listing.jpg'}
                                                            alt={listing.listing_title ? listing.listing_title : 'Untitled Listing'}
                                                            onLoad={() => handleImageLoad(index)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="logo-wrapper">
                                                    <img
                                                        ref={(el) => (logoImgRefs.current[index] = el)}
                                                        src={listing.category_info.category_image_url}
                                                        alt=''
                                                        className='cist'
                                                        onLoad={() => handleImageLoad(index)}
                                                    />
                                                </div>
                                            </div>
                                            <div className='pltxt-box'>
                                                <div className='cat-pointer mb-0'>
                                                    <img src={listing.property_title_icon_image}  alt="Profile" className="pointer-icon" />
                                                    <div className='wspl-ta-section'>
                                                        <span className='wspl-title-box'>{listing.listing_title || 'Unknown Title'}</span>
                                                        <span className='wspl-add-box'>{listing.property_address}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='co-host-box'>
                                                <span className='acc-btn-txt'>Manage</span>
                                            </div>
                                        </div>
                                        
                                    </a>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <p>No active listings found</p>
                    )}
                </div>
            </div>

        </div>
    );
};

export default CoHost;